import { InMemoryCache } from 'apollo-cache-inmemory/lib';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import gql from 'graphql-tag';
import React from 'react';
import { ApolloProvider, Mutation, Query } from 'react-apollo';
import ReactDOM from 'react-dom';
import ThemeProvider from './ThemeProvider';
import { INITIALIZE_WEBCHAT } from './actions/Config/index';
import InteractContainer from './components/InteractContainer';
import { setContext } from 'apollo-link-context';

const base64ToObject = base64 => {
  try {
    return JSON.parse(atob(base64));
  } catch (e) {
    return { ERROR: 'JSON parse failed' };
  }
};

const getPayloadInfo = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const queryPayload = searchParams.get('payload') || searchParams.get('config');
  const hashPayload = window.location.hash ? window.location.hash.replace(/^#/, '') : '';
  const pathPayload = window.location.pathname ? window.location.pathname.replace(/^\/+/, '') : '';

  const candidates = [
    { payload: queryPayload, source: 'query' },
    { payload: hashPayload, source: 'hash' },
    { payload: pathPayload, source: 'path' },
  ];

  let selected = { payload: '', source: 'none', obj: {} };

  for (const candidate of candidates) {
    if (!candidate.payload) continue;
    const obj = base64ToObject(candidate.payload);
    if (obj && !obj.ERROR && obj.channelId) {
      selected = { ...candidate, obj };
      return selected;
    }
    if (!selected.payload) {
      selected = { ...candidate, obj };
    }
  }

  return selected;
};

const { obj: urlObj } = getPayloadInfo();

const CHANNEL_ID = urlObj.channelId;
const OVERWRITE_OPEN = urlObj.open;
const DROPLET = urlObj.droplet;
const HIDE_BUTTON = urlObj.hideButton;
const chatUserId = urlObj.c;
const SESSION_DATA = urlObj.session;
const OPEN_ON_FIRST_TIME = urlObj.openOnFirstTime;

const READ_MESSAGES = gql`
  mutation readMessages($channelId: ID!, $chatUserId: ID!) {
    readMessages(channelId: $channelId, chatUserId: $chatUserId)
  }
`;

const authLink = setContext((_, { headers }) => {
  const token = SESSION_DATA && SESSION_DATA.authToken;
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL });

const cache = new InMemoryCache();
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
  connectToDevTools: true,
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Query query={INITIALIZE_WEBCHAT} variables={{ channelId: CHANNEL_ID }} fetchPolicy="network-only">
      {({ data, loading, error }) => {
        if (loading) {
          return console.log('Loading::', loading) || null;
        }
        if (error) {
          return console.log('Error::', error.message) || <span>ERROR:: {error.message}</span>;
        }
        if (!data) {
          return console.log('No data') || null;
        }

        return (
          <ThemeProvider theme={data.theme || {}}>
            <Mutation mutation={READ_MESSAGES}>
              {readMessagesMutation => (
                <InteractContainer
                  readMessagesMutation={readMessagesMutation}
                  droplet={DROPLET}
                  overwriteOpen={OVERWRITE_OPEN}
                  config={data.theme}
                  hideButton={HIDE_BUTTON}
                  openOnFirstTime={OPEN_ON_FIRST_TIME}
                />
              )}
            </Mutation>
          </ThemeProvider>
        );
      }}
    </Query>
  </ApolloProvider>,
  document.getElementById('root')
);
